/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {GetAllData as subscriberData} from '../../AllContactsList/SubscriberSlice/SubscriberSlice'
import {stopLoading, startLoadding} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  tags: [],
  allTags: [],
  filterTagsContact: [],
  tagsContactCount: [],
}

const RouteUrl = {
  getTotal: 'tags/tags-withought-pagination',
  GetAllData: 'tags',
  GetData: '',
  EditData: '',
  DeleteData: 'tags/deleteTags',
  CreateData: 'tags',
  unassigned: 'group/unAssignTagsFromContact/',
  assigned: 'group/assignTagsToContact/',
  getSegmentTag: 'mobile/group/data',
}
const thunkName = {
  getToatal: 'tags-total',
  GetAllData: 'tags-GetALLDATA',
  GetData: '',
  EditData: '',
  DeleteData: 'tags-Delete',
  CreateData: 'tags-Create',
  unassigned: 'tags-unassigne',
  assigned: 'tags-assigne',
  getSegmentTag: 'getSegmentTag',
}

export const getalltagsdata: any = createAsyncThunk(thunkName.getToatal, async (data, thunkApi) => {
  const response = await axios.get(`${API_URL}${RouteUrl.getTotal}`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  thunkApi.dispatch(stopLoading())
  return response.data
})
export const GetAllData: any = createAsyncThunk(thunkName.GetAllData, async (data: any, thunkApi) => {
  const response = await axios.get(`${API_URL}${RouteUrl.GetAllData}`, {
    params: {...data, isExcludeList: 'true'},
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })

  let ids = response?.data?.data?.items?.map((val: any) => val?._id)
  thunkApi.dispatch(
    TagsCount({
      tagId: ids,
    })
  )
  thunkApi.dispatch(stopLoading())
  return response.data
})
export const TagsCount: any = createAsyncThunk('TagsCount', async (data, thunkApi) => {
  const response = await axios.post(`${API_URL}tags/tagsCount`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  thunkApi.dispatch(stopLoading())
  return response.data
})

export const DeleteData: any = createAsyncThunk(thunkName.DeleteData, async (data, thunkApi) => {
  const response = await axios.put(`${API_URL}${RouteUrl.DeleteData}`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }

  thunkApi.dispatch(GetAllData())
})
export const UnassignetagsContacts: any = createAsyncThunk(
  thunkName.unassigned,
  async (data: any, thunkApi) => {
    const response = await axios.post(`${API_URL}${RouteUrl.unassigned}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // thunkApi.dispatch(subscriberData({id: data?.id?.id, page: data?.id?.page}))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const assignetagsContacts: any = createAsyncThunk(
  thunkName.assigned,
  async (data: any, thunkApi) => {
    const response = await axios.post(`${API_URL}${RouteUrl.assigned}`, data?.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(subscriberData({id: data?.id?.id, page: data?.id?.page}))
    thunkApi.dispatch(stopLoading())

    if (data.callbackFn) {
      data.callbackFn(response)
    }
    return response.data
  }
)
export const addRemoveTagsFromContact: any = createAsyncThunk(
  'addRemoveTagsFromContact',
  async (data: any, thunkApi) => {
    const response = await axios.post(`${API_URL}group/addRemoveTagsFromContact`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response.data
  }
)
export const CreateData: any = createAsyncThunk(
  thunkName.CreateData,
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}${RouteUrl.CreateData}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetAllData())
    thunkApi.dispatch(getalltagsdata())
  }
)
export const UpdateData: any = createAsyncThunk(thunkName.EditData, async (data: any, thunkApi) => {
  thunkApi.dispatch(startLoadding())
  const response = await axios.post(`${API_URL}${RouteUrl.CreateData}/${data?.id}`, data.data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }
  thunkApi.dispatch(stopLoading())
  thunkApi.dispatch(GetAllData())
})

export const GetFilterContactTag: any = createAsyncThunk(
  thunkName.getSegmentTag,
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}${RouteUrl.getSegmentTag}/${data?.id}`, {
      params: data.page,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const TagName = createSlice({
  name: 'TagName',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAllData.fulfilled, (state, action) => {
      return {...state, tags: action?.payload}
    })
    builder.addCase(getalltagsdata.fulfilled, (state, action) => {
      return {...state, allTags: action?.payload}
    })
    builder.addCase(GetFilterContactTag.fulfilled, (state, action) => {
      return {...state, filterTagsContact: action?.payload}
    })
    builder.addCase(TagsCount.fulfilled, (state, action) => {
      return {...state, tagsContactCount: action?.payload}
    })
  },
})

export const getFilterContactTag = (state: any) => state?.tags?.filterTagsContact?.data
export const getTagContactCount = (state: any) => state?.tags?.tagsContactCount?.data

export default TagName.reducer
